import React from 'react';
export const Products = [
    {
        id: 1,
        img: '/img/oil.jpg',
        title: 'Vegetable oils',
        description: `We supply Vegetable, Canola, Sunflower, 
        Cottonseed and Soyabean oil and other 
        speciality oils for deep fry.`,
        link: '#'
    },
    {
        id: 2,
        img: '/img/white-rice-on-a-table.jpg',
        title: 'Rice',
        description: `Looking for rice? We have Thai Jasmine Rice, Medium Grain, Long Grain and Brown Rice. We  also have White or Black Glutinous rice.`,
        link: '#'
    },
    {
        id: 3,
        img: '/img/Spicy-Singapore-Noodles-with-Curry.jpg',
        title: 'Noodles',
        description: `We have a wide selection of fresh, dried, chilled and frozen noodles to suit various dishes. Choose from a
        selection of rice sticks, vermicelli, egg noodles, fresh rice noodles, hokkien noodles, ramen, udon and more. `,
        link: '#'
    },
    {
        id: 4,
        img: '/img/salt-PBA9T2V.png',
        title: 'Sugar and salt',
        description: "Everything from White Sugar, Raw Sugar, Caster Sugar, Palm Sugar and Flossy Salt.",
        link: '#'
    },
    {
        id: 5,
        img: '/img/fresh-farm-eggs-P6EGPRK.png',
        title: 'Eggs',
        description: "Our fresh farm eggs delivered daily and kept chilled to maintain freshness all year round. We also supply locally grown salted and century duck eggs.",
        link: '#'
    },
    {
        id: 6,
        img: '/img/various-spices-on-dark-49RZD6E.png',
        title: 'Herbs & Spices',
        description: `Vast range including various peppers, chillis, paprika, garlic, cumin powder and more. Vast range of "Asian"  herbs including star aniseeds, lotus roots, black fungus strips, cinnamon sticks and more.`,
        link: '#'
    },
    {
        id: 7,
        img: '/img/flour.jpg',
        title: 'Flour & Starch',
        description: "Whether you are creating dumplings, making noodles and making fried chicken, we have a range of products to suit from ultra white flour, self raising flour to corn flour, potato starch and speciality batter mixes.",
        link: '#'
    },
    {
        id: 8,
        img: '/img/tofu_1.jpg',
        title: 'Tofu',
        description: " We carry soft tofu, firm tofu, fried tofu and tofu puff. Our tofu is delivered fresh and kept chilled to ensure freshness and quality.",
        link: '#'
    },
    {
        id: 9,
        img: '/img/packedveg.jpg',
        title: 'Packaged Vegetables & Fruits',
        description: "An extensive range of products varying from dried and canned mushrooms, black fungus strips, pickled raddish, ginger strips to canned corn, pineapple chunks, lychees, peeled garlic and mango puree.",
        link: '#'
    },
    {
        id: 10,
        img: '/img/sauces-PWMK4Q7.png',
        title: 'Sauces & Pastes',
        description: "Everything from BBQ sauce to soy sauce including fish sauce, sweet chilli sauce, chilli-jam, oyster sauce, Hoisin sauce, ground bean sauce, chilli bean Sauce, Plum sauce, Peanut Butter, tomato sauce paste, shrimp paste, tom-yum paste, honey and more.",
        link: '#'
    },
    {
        id: 11,
        img: '/img/traditional-curry-and-ingredients-RA46QKE.png',
        title: 'Coconut Milk & Curry',
        description: `We stock an endless supply of Kara, Maeploy and Chef's Choice coconut milk.
        A necessity in all Thai restaurants: Green, Red, Yellow, Panang, Massaman and more`,
        link: '#'
    },
    {
        id: 12,
        img: '/img/seafood-NQMYHXL.png',
        title: 'Seafood',
        description: "We store a limited variety frozen seafood. We carry pretty much everything from barramundi, ling, basa, raw and cooked prawns, squids tubes, soft shell crab and more.",
        link: '#'
    },
    {
        id: 13,
        img: '/img/bread-main.jpg',
        title: 'Frozen Pastry',
        description: "Puff Pastry, Short Curst Pastry, Wonton Pastry... We store a range of reputable ready to use products to suit different cuisines.",
        link: '#'
    },
    {
        id: 14,
        img: '/img/frozen-food.jpg',
        title: 'Frozen Products(Ready to Cook)',
        description: "We've partnered up with some of the best local and internationally recognised manufacturers of Asian cuisine to bring you some of the best tasting food service products. Everything from prawns dim sims, curry puffs, BBQ Pork Buns to vegetarian gyoza's and nested spring rolls.",
        link: '#'
    },
    {
        id: 15,
        img: '/img/nuts.jpg',
        title: 'Nuts & Beans',
        description: "Small goods which makes famous dishes possible. We stock a vast array of ingredients from Red Beans, Grean Beans, Black Eyed Beans, Kidney Beans to Peeled Peanuts and Cashew Nuts.",
        link: '#'
    },
    {
        id: 16,
        img: '/img/red-wine-vinegar.jpg',
        title: 'Cooking Wine & Vinegar',
        description: "Essentials to every Asian Kitchen. We store and supply the best brands at competitive prices.",
        link: '#'
    },
    {
        id: 17,
        img: '/img/non_alcoholic_beverages.jpg.png',
        title: 'Beverages',
        description: "We carry more than just still or sparking water. Our team have  sourced Tea from China and Thailand, as well as enjoyable refreshments from Korea to Iceland.",
        link: '#'
    },
    {
        id: 18,
        img: '/img/rools.png',
        title: 'EFTPOS & Printing ',
        description: "Low on Eftpos rolls or printer rolls for your kitchen? We stock a variety of plain and thermal paper rolls to keep your business running.",
        link: '#'
    },
    {
        id: 19,
        img: '/img/koreanstreetfood43.jpg',
        title: 'Korean Ice-cream & Snacks',
        description: "Think Binnggrae, Lotte, Lavelee and Hatai. These are top Ice-Creams and confectionary brand in Korea. We have introduced Korea's best ice-creams and snacks to consumers in Sydney by working with leading retailers and super market stores.",
        link: '#'
    },
    {
        id: 20,
        img: '/img/banner5.png',
        title: 'Packaging',
        description: " Everthing from takeaway containers, disposable cutlery, foil and ling wrap, to snack packs, dinner packs and disposable cups.",
        link: '#'
    },
    {
        id: 21,
        img: '/img/cleaning-cloth-and-detergent-K8FUJ2H.png',
        title: 'Cleaning Products',
        description: "From the kitchen to the washroom. We carry everything between the chef's disposable gloves, wipes, paper towels, detergents to toilet papers and no rinse sanitisers.",
        link: '#'
    }

];
const ProductSection = (props) => {
    return (
        <div className="fullwidth productSection section text-center" id="ProductSection">
            <div className="container">
                <h2 className="red">Product
                        <span>Range</span>
                </h2>
                <div className="row">
                    { Products.map(column => {
                        return (
                            <div className="col-sm-4 col-12" key={ column.id }>
                                <div className="product-box">
                                    <h4>{ column.title }</h4>
                                    <div className="product-img">
                                        <img alt="bw1" src={ column.img } />
                                    </div>
                                    <p>
                                        { column.description }
                                    </p>
                                </div>
                            </div>
                        )
                    }
                    )
                    }
                </div>
                <div className="row contact-wrapper">
                    <div className="col-sm-12 col-12">
                        <p>CP Food Service continually looks to update the product range. There is more to our product range than listed on our website. </p>
                        <p>If you are looking for a specific item,<br /> drop us an email or fill out the enquiry form on the "Contact Us" page. </p>
                        <a href="#contact-us" className="btn">Contact Us</a>
                    </div>
                </div>
            </div>
        </div>
    )

}


export default ProductSection


// WEBPACK FOOTER //
// ./src/components/Home/Product-Section.js